module.exports = {"632723100":"称文镇","632723101":"歇武镇","632723102":"扎朵镇","632723103":"清水河镇","632723104":"珍秦镇","632723200":"尕朵乡","632723201":"拉布乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632723.json
// module id = 3013
// module chunks = 0